import type { CargoRes } from 'api/swagger';
import { getLdmForAverageCargoCost } from 'shared/utils/ldm';
import { numberFormatter } from 'shared/utils/numbers/formatter';
import { round10 } from 'shared/utils/numbers/round';
import { CargoType } from 'types/cargo';

export type TAverageCargoPrice = {
  value: number;
  suffix: '€/LDM' | '€/km';
};

export const calculateAverageCargoPrice = (cargo: CargoRes): TAverageCargoPrice | null => {
  if (!cargo.order) return null;

  switch (cargo.type) {
    case CargoType.LTL:
    case CargoType.PART_LOAD:
      return {
        value: cargo.order.freightInDefault / getLdmForAverageCargoCost(cargo),
        suffix: '€/LDM',
      };
    case CargoType.FTL:
    case CargoType.CONTAINER:
      return cargo.totalKm
        ? {
            value: cargo.order.freightInDefault / cargo.totalKm,
            suffix: '€/km',
          }
        : null;
  }

  return null;
};

export const calculateCostPerItem = (cargo: CargoRes): string | null => {
  const averagePrice = calculateAverageCargoPrice(cargo);

  return averagePrice?.value ? `${numberFormatter(round10(averagePrice.value))} ${averagePrice.suffix}` : null;
};
